var _defs, _path, _path2, _polygon, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashBuilder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#800080;}.cls-2,.cls-3{fill:#fff;}.cls-2{fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,17a7,7,0,1,1,7-7A7,7,0,0,1,10,17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.14,10.2v.42h.71V13h4.28a2.25,2.25,0,0,1-.74-.59H7.45V10.2L10,7.66l1.26,1.27a2.27,2.27,0,0,1,.9-.19h.23L10,6.36Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.53 7.06 8.67 7.06 8.67 7.37 7.53 8.52 7.53 7.06"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.14,9a2,2,0,1,0,2,2A2,2,0,0,0,12.14,9Zm.2,2.76v.29H12v-.3a.78.78,0,0,1-.47-.26.74.74,0,0,1-.18-.51.79.79,0,0,1,.65-.8v-.3h.37v.28a1,1,0,0,1,.28.06l-.08.42a.53.53,0,0,0-.26,0,.34.34,0,0,0-.37.37.35.35,0,0,0,.38.37.84.84,0,0,0,.29,0l.06.41A.89.89,0,0,1,12.34,11.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashBuilder);
export default __webpack_public_path__ + "static/media/cashBuilder.bab467c31f643c8a312e55bdc6d5dc2f.svg";
export { ForwardRef as ReactComponent };